
<div class="maintenance-container">
  
    <!-- Main Content -->
    <main class="main-content">
  
      <div class="maintenance-content">
        <div class="button-section">
          <img
            class="arrow-icon" 
            src="assets/images/back-icon.svg"
            (click)="navigateBack()" 
          />
        </div>
        <div class="illustration">
          <img src="../assets/images/maintenance.svg" alt="Maintenance Illustration" class="maintenance-image">
        </div>
  
        <h1 class="maintenance-title">Page is Under Maintenance</h1>
        
        <p class="maintenance-message">
          Our site is currently undergoing maintenance. We apologize for any inconvenience and appreciate your patience.
        </p>
        
        <p >
          <strong class="contact-info">Contact Us:</strong> <span class="contact-text"> you have any urgent queries, please reach out to us at </span>
          <a href="mailto:gsdsupport@innovasolution.com" class="support-email">gsdsupport@innovasolution.com</a>
        </p>
      </div>
    </main>
  
  </div>
  